import $ from 'jquery';

import application from 'application/application';

import 'air-datepicker/dist/js/datepicker';

const LABELS_DEFINITIONS = {
	days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
	daysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
	daysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	months: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho', 'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
	monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
	today: 'Hoje',
	clear: 'Limpar'
};

$.fn.datepicker.language['pt-BR'] = {
	...LABELS_DEFINITIONS,
	dateFormat: 'dd/mm/yyyy',
	timeFormat: 'hh:ii aa',
	firstDay: 0
};

application

	.directive('airDatepicker', [() => {

		return {
			scope: {},
			link: (scope, element, attrs) => {
				let options = scope.$parent[attrs.inlineDatepicker];

				if (options === null || typeof options !== 'object')

					options = {};

				const { ArrowButton } = Components();

				let tagName = $(element).prop('tagName');

				if (tagName === 'INPUT') {
					$(element).datepicker({
						language: 'pt-BR',
						autoClose: true,
						prevHtml: ArrowButton('left'),
						nextHtml: ArrowButton('right')
					});
				} else {
					let id = $(element).attr('data-id');

					let $btn = $(element),
						$input = $(`#${id}`),
						dp = $input.datepicker({ showEvent: 'none' }).data('datepicker');

					$btn.on('click', () => {
						dp.show();
						$input.focus();
					});
				}
			}
		};

	}]);

function Components() {
	const components = {
		DayCell: ({ day } = {}) => `<span aria-highlited-day="false">${day}</span>`,
		YearCell: ({ year } = {}) => `<span aria-highlited-day="false">${year}</span>`,
		MonthCell: ({ month, datepicker } = {}) => LABELS_DEFINITIONS[datepicker.opts.monthsField][month],
		ArrowButton(side) {
			return `
				<button type="button" class="btn btn-link">
					<i class="fa fa-chevron-${side}" aria-hidden="true"></i>
				</button>
			`;
		},
		HighlitedDayCell({ day } = {}) {
			return `
				<div class="highlited-day" aria-highlited-day="true">
					<div class="highlited-day__text">
						${day}
					</div>
					<div class="highlited-day__dot fadeIn">
						<span class="calendar-square"></span>
					</div>
				</div>
			`;
		}
	};

	Object.keys(components).forEach(componentName => Components[componentName] = components[componentName]);

	return components;
}
